<template>
    <div>
        <CList @FiltrarC="Lista" :pConfigList="ConfigList" :pFiltro="Filtro" :segurity="segurity">
            <template slot="Filtros">
                <div class="col-auto">
                    <div class="btn-group" role="group" aria-label="basic">
                        <button type="button" class="btn btn-sm btn-primary" @click="SeleccionLista('PorVencer')">Por Vencer</button>
                        <button type="button" class="btn btn-sm btn-primary" @click="SeleccionLista('PorFecha')">Por Fecha</button>
                        <button type="button" class="btn btn-sm btn-primary" @click="SeleccionLista('Todos')">Todos</button>
                        <button type="button" class="btn btn-sm btn-primary" @click="SeleccionLista('Pagadas')">Pagadas</button>
                    </div>
                </div>
                <Transition>
                    <div class="form-inline" v-show="BotonMenu.PorFecha">
                        <div class="row form-group">
                            <div class="col-lg-4">
                                <label for="">Fecha Inicial</label>
                                <Datepicker @input="Lista" v-model="Filtro.FechaFiltro.Inicio" :input-class="Setpicker.Style" :format="Setpicker.Formato" :language="Setpicker.Idioma" placeholder="0000-00-00"></Datepicker>
                            </div>
                            <div class="col-lg-4">
                                <label for="">Fecha Final</label>
                                <Datepicker @input="Lista" v-model="Filtro.FechaFiltro.Fin" :input-class="Setpicker.Style" :format="Setpicker.Formato" :language="Setpicker.Idioma" placeholder="0000-00-00"></Datepicker>
                            </div>
                        </div>
                    </div>
                </Transition>
            </template>

            <template slot="AntTabla">
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-lg-12">
                            <h3>Datos de Pago</h3>
                        </div>
                    </div>
                    <div class="row mb-3">
                        <div class="col-lg-3">
                            <span class="bold text-black">Razón Social:</span> <span>{{ ObjProveedor.RazonSocial }}</span>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-3">
                            <span class="bold text-black">Banco:</span> <span>{{ ObjProveedor.Banco }}</span>
                        </div>
                        <div class="col-lg-3">
                            <span class="bold text-black">N° de Cuenta:</span> <span>{{ ObjProveedor.NCuenta }}</span>
                        </div>
                        <div class="col-lg-3">
                            <span class="bold text-black">Clabe Interbancaria:</span> <span>{{ ObjProveedor.Clabe }}</span>
                        </div>
                        <div class="col-lg-3">
                            <span class="bold text-black">N° de Tarjeta:</span> <span>{{ ObjProveedor.Tarjeta }}</span>
                        </div>
                    </div>
                </div>
            </template>

            <template slot="header">
                <th :class="StyleTh+' text-center'">#</th>
                <th :class="StyleTh">Proveedor</th>
                <th :class="StyleTh">N° Nota/N° Factura</th>
                <th :class="StyleTh">Concepto</th>
                <th :class="StyleTh">Importe</th>
                <th :class="StyleTh">Fecha de Compra</th>
                <th :class="StyleTh">Fecha de Pago</th>
                <th :class="StyleTh">Estatus</th>
                <th :class="StyleTh+' text-center'">Acciones</th>
            </template>

            <template slot="body">
                <tr v-for="(lista,index) in ListaArrayRows" :key="index">
                    <td class="text-center"><p :class="StyleTd">{{(index+1)}}</p></td>
                    <td><h6 :class="StylePr">{{lista.proveedor.RazonSocial}}</h6></td>
                    <td><p :class="StyleTd">{{lista.NumDeCompra}}</p></td>
                    <td><p :class="StyleTd">{{lista.Concepto}}</p></td>
                    <td><p :class="StyleTd">$ {{lista.Importe}}</p></td>
                    <td><p :class="StyleTd">{{$getCleanDate(lista.FechaCompra,false)}}</p></td>
                    <td><p :class="StyleTd">{{$getCleanDate(lista.FechaPago,false)}}</p></td>
                    <td><p :class="StyleTd">{{lista.Estatus!='Pagado' && EstaVencida(lista.FechaPago) ? 'Vencida' : lista.Estatus}}</p></td>
                    <td class="align-middle text-end">
                        <CBtnAccion :pShowBtnEdit="lista.Estatus!='Pagado' ? true : false" :pShowBtnDelete="lista.Estatus!='Pagado' ? true : false" :pIsModal="true" :pId="lista.IdCuentaPagar" :pEmitSeccion="ConfigList.EmitSeccion" :segurity="segurity">
                            <template slot="btnaccion">
                                <CMoreButtonsL>
                                    <template slot="bodyBtnsL">
                                        <li @click="PagarCuenta(lista.IdCuentaPagar)">
                                            <a class="dropdown-item">
                                                <div v-show="lista.Estatus=='Pendiente'">
                                                    <i class="far fa-hand-holding-usd"></i> Pagar
                                                </div>
                                            </a>
                                        </li>
                                        <li v-show="lista.Xml!=NULL">
                                            <a class="dropdown-item">
                                                <div>
                                                    <i class="far fa-file-certificate"></i> Descargar XML
                                                </div>
                                            </a>
                                        </li>
                                    </template>
                                </CMoreButtonsL>
                            </template>
                        </CBtnAccion>
                    </td>
                </tr>
                <CSinRegistros :pContIF="ListaArrayRows.length" :pColspan="9"></CSinRegistros>
            </template>

        </CList>

        <CModal :pConfigModal="ConfigModal" :poBtnSave="oBtnSave">
			<template slot="Form">
				<Form :poBtnSave="oBtnSave"></Form>
			</template>
		</CModal>
    </div>
</template>

<script>
import moment from 'moment';
import Calendar from '@/helpers/StaticComboBox.js';
import Form from './Form.vue';
import FormPagar from './Pagar.vue';
import Configs from '@/helpers/VarConfig.js';
const EmitEjecuta = 'seccionCuentasPagar';
const EmitEjecuta2='seccionPagar';

export default {
    name:'ListaCuentasPagar',
    props:['pOrigen','pObjProveedor'],
    components:{Form,FormPagar},
    data() {
        return {
            ConfigList:{
                Title: 'Cuentas Por Pagar',
                IsModal: true,
                ShowLoader: true,
                EmitSeccion: EmitEjecuta,
                BtnReturnShow: true,
                TitleFirst: 'Finanzas',
            },
            Filtro:{
                Nombre: '',
                Pagina: 1,
                Entrada: 25,
                TotalItem: 0,
                Placeholder: 'Buscar..',
                Estatus:'',
                FechaFiltro:{
                    Inicio:'',
                    Fin:''
                },
                IdProveedor:''
                /*Anio: moment(new Date()).format('YYYY'),*/
            },
            ConfigModal:{
                ModalTitle: "Cuentas Por Pagar",
                ModalNameId: 'ModalForm',
                EmitSeccion: EmitEjecuta,
                ModalSize:'lg'
            },
            oBtnSave:{
                Toast: 0,
                IsModal: true,
                DisableBtn: false,
                EmitSeccion: EmitEjecuta,
            },
            ConfigModalPagar:{
                ModalTitle: "Pagar",
                ModalNameId: 'ModalForm',
                EmitSeccion: EmitEjecuta2,
            },
            oBtnSavePagar:{
                Toast: 0,
                IsModal: true,
                DisableBtn: false,
                EmitSeccion: EmitEjecuta2,
            },
            segurity: {},
            obj: {},
            ListaArrayRows: [],
            StyleTh: Configs.stylesTable.StyleTh,
            StylePr: Configs.stylesTable.StylePr,
            StyleTd: Configs.stylesTable.StyleTd,
            Setpicker:Calendar.calendarSettings,
            UrlApi:'',
            Tipo:'',
            BotonMenu:{
                PorVencer:true,
                PorFecha:false,
                Todos:false,
                Pagadas:false
            },
            ObjProveedor:{}
        }
    },
    methods: {
        async Lista(){
            this.ListaArrayRows=[];
            this.UrlApi='/cuentaPorPagar'
            this.Filtro.Estatus='Pendiente';
            this.Tipo='';
            let params={
                TxtBusqueda:this.Filtro.Nombre,
                Entrada:this.Filtro.Entrada,
                Pag:this.Filtro.Pagina,
                Estatus:this.Filtro.Estatus,
                Tipo:this.Tipo,
                IdProveedor:this.ObjProveedor.IdProveedor
            }
            if (this.BotonMenu.PorVencer) {
                this.Tipo='PorVencer';
                this.Filtro.Estatus='Pendiente';
                params.Tipo=this.Tipo;
                params.Estatus=this.Filtro.Estatus;
            }
            if (this.BotonMenu.PorFecha) {
                params.FechaInicio='';
                params.FechaFin='';
                if (this.Filtro.FechaFiltro.Inicio!='') {
                    let YearInicio=this.Filtro.FechaFiltro.Inicio.getFullYear();
                    let MonthInicio=this.Filtro.FechaFiltro.Inicio.getMonth()+1;
                    let DayInicio=this.Filtro.FechaFiltro.Inicio.getDate();
                    params.FechaInicio=YearInicio+'-'+MonthInicio+'-'+DayInicio;
                }
                if (this.Filtro.FechaFiltro.Fin!='') {
                    let YearFin=this.Filtro.FechaFiltro.Fin.getFullYear();
                    let MonthFin=this.Filtro.FechaFiltro.Fin.getMonth()+1;
                    let DayFin=this.Filtro.FechaFiltro.Fin.getDate();
                    params.FechaFin=YearFin+'-'+MonthFin+'-'+DayFin;
                }

                this.Tipo='PorFecha';
                this.Filtro.Estatus='Pendiente';
                params.Tipo=this.Tipo;
                params.Estatus=this.Filtro.Estatus;
            }
            if (this.BotonMenu.Pagadas) {
                this.Tipo='Pagadas'
                this.Filtro.Estatus='Pagado';
                params.Tipo=this.Tipo;
                params.Estatus=this.Filtro.Estatus;
            }
            this.ConfigList.ShowLoader = true;
            this.$http.get(this.UrlApi,{
                // params:{
                //     TxtBusqueda: this.Filtro.Nombre,
                //     Entrada: this.Filtro.Entrada,
                //     Pag: this.Filtro.Pagina,
                //     Estatus:this.Filtro.Estatus,
                //     FechaInicio:this.Filtro.FechaFiltro.Inicio,
                //     FechaFin:this.Filtro.FechaFiltro.Fin,
                //     Tipo:this.Tipo
                // }
                params:params
            }).then((res)=>{
                this.Filtro.Pagina      = res.data.data.current_page;
                this.Filtro.TotalItem   = res.data.data.total;
                this.ListaArrayRows     = res.data.data.data;
            }).finally(()=>{
                this.ConfigList.ShowLoader = false;
            })
        },
        Eliminar(Id){
            this.$swal(Configs.configEliminar).then((result) =>
            {
                if(result.value)
                {
                    this.$http.delete('/cuentaPorPagar/'+Id
                    ).then((res) => {
                        this.$swal(Configs.configEliminarConfirm);
                        this.Lista();
                    }).catch(err => {
                        this.$toast.error(err.response.data.message);
                    });
                } 
            });
        },
        Regresar(){
            this.$router.push({name:'cuentaporpagar',params:{}});
        },
        SeleccionLista(index){
            this.Filtro.FechaFiltro.Inicio='';
            this.Filtro.FechaFiltro.Fin='';
            let BotonMenu=this.BotonMenu;
            Object.keys(BotonMenu).forEach(function(key,ind){
				if (key==index) {
					BotonMenu[key]=true;
				}
				else{
					BotonMenu[key]=false;
				}
				// console.log(index)
			});
            this.Lista();
        },
        PagarCuenta(index){
            this.$swal(Configs.configPagarCuenta).then((result) =>
            {
                if(result.value)
                {
                    this.$http.post('/cuentaPorPagarPagada/'+index
                    ).then((res) => {
                        this.$swal(Configs.configPagarCuentaConfirm);
                        this.Lista();
                    }).catch(err => {
                        this.$toast.error(err.response.data.message);
                    });
                } 
            });
        },
        EstaVencida(FechaAEvaluar){
            let formatedDate = FechaAEvaluar.replace(/-/g, "\/");
            let FechaCuenta=new Date(formatedDate);
            let FechaActual=new Date();
            if (FechaActual.getTime()>FechaCuenta.getTime()) {
                return true; 
            }
            else{
                return false;
            }
        },
        IrACuentasProveedor(item){

        }
    },
    created() {
        if(this.pOrigen != undefined){
            sessionStorage.setItem('menuOrigen',JSON.stringify(this.pOrigen));
        }
        if(this.pObjProveedor != undefined){
            sessionStorage.setItem('proveedor',JSON.stringify(this.pObjProveedor));
        }

        let Origen = JSON.parse(sessionStorage.getItem('menuOrigen'));
        this.ObjProveedor=JSON.parse(sessionStorage.getItem('proveedor'));
        this.Filtro.IdProveedor=this.ObjProveedor.IdProveedor;
        if(Origen){
            this.ConfigList.TitleFirst = Origen;
        }
        else{
            this.ConfigList.ShowTitleFirst = false;
        }
        this.bus.$off('Delete_'+EmitEjecuta);
        this.bus.$off('List_'+EmitEjecuta);
        this.bus.$off('EmitReturn');
    },
    mounted() {
        this.Lista();
        this.bus.$on('Delete_'+EmitEjecuta,(Id)=>
        {
            this.Eliminar(Id);
        });
        this.bus.$on('List_'+EmitEjecuta,()=>
        {
            this.Lista();
        });

        this.bus.$on('EmitReturn',()=>
        {
            this.Regresar();
        });
    },
}
</script>

<style>

</style>